//import Index from '../Index'

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('../Index.vue')
    }
]